import { useSelector, shallowEqual } from 'react-redux';

const useUserTimezone = () =>
    useSelector(
        (state) => state.timezone?.timezone ?? state.timezone?.autodetected_timezone,
        shallowEqual
    );

export default useUserTimezone;
